import React from "react";
import ReactDOMClient from "react-dom/client";

import App from "./App";

// import { DivWrapperScreen } from "./screens/DivWrapperScreen/DivWrapperScreen";
import { BhHomepageMain } from "./pages/BhHomepageMain";

const app = document.getElementById("app");
const root = ReactDOMClient.createRoot(app);

root.render(<App />);